import { render, staticRenderFns } from "./AddService.vue?vue&type=template&id=0bd5d426&scoped=true"
import script from "./AddService.vue?vue&type=script&lang=js"
export * from "./AddService.vue?vue&type=script&lang=js"
import style0 from "./AddService.vue?vue&type=style&index=0&id=0bd5d426&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5d426",
  null
  
)

export default component.exports